export const TransferType = {
  InstantPay: "instant_pay",
  EmergencyPay: "emergency_pay",
  InstantTransfer: "instant_transfer",
} as const;
export type TransferType = (typeof TransferType)[keyof typeof TransferType];
